let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4iBzE")).then(() => parcelRequire('GXzcY'));